// SOP & editor attachment helpers — extracted from legacy-utils.ts

import { App } from '@/services/app-compat';

export var editorAttachmentKeys: Record<string, any> = {};

export enum ATTACHMENT_TYPES {
  SOP_EDITOR = 'sop_editor',
  USER_PROFILE_NOTES_EDITOR = 'user_profile_notes_editor',
  CASE_REPORT_NARRATIVE_EDITOR = 'case_report_narrative_editor'
}

export function loadNocSopImages(
  htmlContent: string,
  natureOfCallCode: number,
  companyId: number,
  callback: (processedContent: string) => void,
  errorCallback?: () => void
): void {
  const temp = document.createElement('div');
  temp.innerHTML = htmlContent;
  const images = temp.querySelectorAll('img[data-attachment-id]');

  if (images.length === 0) {
    callback(htmlContent);
    return;
  }

  const spinnerSvg = 'data:image/svg+xml;base64,' + btoa(
    '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">' +
    '<circle cx="25" cy="25" r="20" fill="none" stroke="#ccc" stroke-width="4"/>' +
    '<path fill="none" stroke="#666" stroke-width="4" stroke-linecap="round" d="M25 5 A20 20 0 0 1 45 25">' +
    '<animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>' +
    '</path></svg>'
  );

  images.forEach(img => {
    if (!img.getAttribute('src') || img.getAttribute('src') === '') {
      img.classList.add('img-loading');
      img.setAttribute('src', spinnerSvg);
    }
  });

  (window as any).api.listCompanyNatureOfCallAttachments(natureOfCallCode, companyId, (result: any) => {
    const attachmentList = result.attachmentList;

    if (!attachmentList || attachmentList.length === 0) {
      callback(temp.innerHTML);
      return;
    }

    const attachmentMap: Record<string, string> = {};
    for (let i = 0; i < attachmentList.length; i++) {
      const id = String(attachmentList[i].id);
      attachmentMap[id] = attachmentList[i].signedURL;
    }

    images.forEach(img => {
      const attachmentId = String(img.getAttribute('data-attachment-id'));
      if (attachmentMap[attachmentId]) {
        img.setAttribute('src', attachmentMap[attachmentId]);
        img.classList.remove('img-loading');
      }
    });

    callback(temp.innerHTML);
  }, (error: any) => {
    console.error("Error loading NOC SOP images:", error);
    App.showPopupNotification("Failed to load images", "error");
    if (errorCallback) {
      errorCallback();
    }
    callback(temp.innerHTML);
  });
}

export function stripImageSrcForSave(htmlContent: string): { content: string, attachmentInfoList: { id: number }[] } {
  if (!htmlContent || htmlContent.indexOf('data-attachment-id') === -1) {
    return { content: htmlContent, attachmentInfoList: [] };
  }

  const temp = document.createElement('div');
  temp.innerHTML = htmlContent;
  const images = temp.querySelectorAll('img[data-attachment-id]');
  const attachmentInfoList: { id: number }[] = [];

  images.forEach(img => {
    const attachmentId = img.getAttribute('data-attachment-id');
    if (attachmentId) {
      const id = parseInt(attachmentId);
      attachmentInfoList.push({ id: id });
    }
    img.setAttribute('src', '');
  });

  return {
    content: temp.innerHTML,
    attachmentInfoList: attachmentInfoList
  };
}
